export default __webpack_public_path__ + "static/media/blob-1.d0f4be76.svg";